// extracted by mini-css-extract-plugin
export default {"governance_footer":"GovernanceFooter_governance_footer__0WnmI"};